var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"p-order-detail"},[(_vm.policy)?_c('v-layout',[_c('v-flex',[(this.productIds.indexOf(Number(this.productId)) !== -1)?_c('aig',{attrs:{"policy":_vm.policy}}):_vm._e()],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }